(() => {
  const init = (header) => {
    const trigger = header.querySelector('[data-zj-search-open]');
    const overlay = header.querySelector('[data-zj-search-overlay]');
    const input = header.querySelector('[data-zj-search-input]');
    if (!trigger || !overlay || !input || overlay.dataset.ready) return;
    overlay.dataset.ready = 'true';

    const toggleEmpty = () => header.querySelector('[data-zj-search-empty]')?.toggleAttribute('hidden', input.value.trim().length > 0);
    const close = () => {
      if (overlay.hidden) return;
      overlay.hidden = true;
      document.body.classList.remove('zj-search-is-open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    };
    const open = (event) => {
      if (!matchMedia('(min-width: 990px)').matches) return;
      event.preventDefault();
      overlay.style.setProperty('--zj-search-top', `${header.getBoundingClientRect().bottom}px`);
      overlay.hidden = false;
      document.body.classList.add('zj-search-is-open');
      trigger.setAttribute('aria-expanded', 'true');
      toggleEmpty();
      requestAnimationFrame(() => input.focus());
    };

    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', open);
    overlay.querySelectorAll('[data-zj-search-close]').forEach((button) => button.addEventListener('click', close));
    input.addEventListener('input', toggleEmpty);
    input.form.addEventListener('reset', () => requestAnimationFrame(toggleEmpty));
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') return close();
      if (event.key !== 'Tab') return;
      const focusable = [...overlay.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  };
  const initAll = (scope = document) => scope.querySelectorAll('.zj-site-header').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
